import { useRef, useState } from 'react';
import { Icon, PixIcon } from '@/components/foundations';
import { Button, ColorField, PaymentMethodRow, PaymentMethods, TextField } from '@/components/forms';
import { AppShell, PageTitle, TopBar } from '@/components/layout';
import { CHECKOUT_URL } from '@/mocks/merchant';
import { CheckoutPreview, CheckoutStatusBar } from './components';

const DEFAULT_DESC = 'Revise os detalhes e escolha a forma de pagamento.';

/** Configurar checkout com pré-visualização ao vivo — fiel a design/html/checkout.html (mock, sem salvar). */
export function CheckoutPage() {
  const prevRef = useRef<HTMLDivElement>(null);
  const [store, setStore] = useState('Loja Exemplo');
  const [desc, setDesc] = useState('Pagamento seguro e rápido');
  const [descTouched, setDescTouched] = useState(false);
  const [color, setColor] = useState('#e5b84c');
  const [opt, setOpt] = useState<'card' | 'pix'>('card');
  const [methods, setMethods] = useState({ pix: true, card: true });
  const [saved, setSaved] = useState(false);
  const toggle = (k: 'pix' | 'card', on: boolean) => {
    const next = { ...methods, [k]: on };
    setMethods(next);
    if (!on && opt === k) {
      const other = k === 'pix' ? 'card' : 'pix';
      if (next[other]) setOpt(other);
    }
  };
  const onSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 1400);
  };
  return (
    <AppShell>
      <main className="content">
  <TopBar user={{ initials: 'LO', name: 'Loja Exemplo', gold: true }} />
  <PageTitle
    variant="checkout"
    title="Configurar checkout"
    subtitle="Defina como seus clientes vão pagar."
    actions={
    <CheckoutStatusBar url={CHECKOUT_URL} />
    }
  />
  <section className="ck-grid">
    <div className="card">
      <h2>Pré-visualização</h2>
      <CheckoutPreview
        id="prev"
        ref={prevRef}
        storeName={store}
        description={descTouched ? desc || DEFAULT_DESC : DEFAULT_DESC}
        amount={489.9}
        color={color}
        methods={methods}
        selected={opt}
        onSelect={setOpt}
        url={CHECKOUT_URL}
      />
    </div>
    <div className="card">
      <h2>Informações do checkout</h2>
      <TextField id="store" label="Nome da loja" value={store} onChange={(e) => setStore(e.target.value)} hint="Esse nome será exibido na página de pagamento." />
      <TextField id="desc" label="Descrição" value={desc} onChange={(e) => { setDesc(e.target.value); setDescTouched(true); }} hint="Breve descrição que aparecerá para o cliente." />
      <div className="field"><span className="label">Métodos de pagamento</span>
        <PaymentMethods>
          <PaymentMethodRow id="pix" icon={<PixIcon />} title="Pix" description="Permitir pagamento via Pix" checked={methods.pix} onToggle={(on) => toggle('pix', on)} />
          <PaymentMethodRow id="card" icon={<Icon name="card" />} title="Cartão de crédito" description="Permitir pagamento com cartão de crédito" checked={methods.card} onToggle={(on) => toggle('card', on)} />
        </PaymentMethods>
      </div>
      <div className="field"><span className="label">Cor primária</span>
        <ColorField value={color} onChange={setColor} hint="Cor usada em botões e destaques do checkout." />
      </div>
      <div className="form-actions">
        <Button variant="outline-gold" id="viewbtn" icon="eye" onClick={() => prevRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })}>Visualizar checkout</Button>
        <Button id="savebtn" icon="save" onClick={onSave}>{saved ? 'Salvo!' : 'Salvar alterações'}</Button>
      </div>
    </div>
  </section>
</main>
    </AppShell>
  );
}
